import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './Button';
export function FinalCTA() {
  return <section id="final-cta" className="py-32 px-4 relative overflow-hidden scroll-mt-16" data-id="element-21" data-mp="3udfc7a8y1rnh">
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_bottom,_var(--tw-gradient-stops))] from-green-900/20 via-background to-background -z-10" data-id="element-22" data-mp="c7k61z6m2ppe" />

      <motion.div initial={{
      opacity: 0,
      scale: 0.95
    }} whileInView={{
      opacity: 1,
      scale: 1
    }} viewport={{
      once: true
    }} className="max-w-4xl mx-auto text-center" data-id="element-23" data-mp="m4ow4a3kv5bh">
        <h2 className="text-4xl md:text-6xl font-extrabold mb-6 tracking-tight" data-id="element-24" data-mp="vwksngq0mndl">
          The Second Half is <br className="md:hidden" data-id="element-25" data-mp="qy189kr2ljnc" />
          <span className="text-green-400" data-id="element-26" data-mp="14uobu6dj3828">Yours for the Taking.</span>
        </h2>

        <p className="text-xl text-gray-400 mb-10 font-medium" data-id="element-27" data-mp="zwv9xpj9d07r">
          Join the Reboot. Reclaim the Edge. Finish 2026 Strong.
        </p>

        <Button href="https://life-shift-362.myshopify.com/cart/52246321594658:1" className="text-lg md:text-xl px-10 py-5 w-full md:w-auto" data-id="element-28" data-mp="2c67r4m52pg7g">
          START MY SECOND-HALF REBOOT ($27)
        </Button>
      </motion.div>
    </section>;
}